import Emitter from 'component-emitter';
import { HubConnection } from '@microsoft/signalr';

type NotificationsUpdatedPayload = {
  unreadNotificationsCount: number;
};

export class NotificationsConnection {
  constructor(hubConnection: HubConnection, emmitter: Emitter) {
    hubConnection.on('NotificationsUpdated', (payload: NotificationsUpdatedPayload) => {
      return emmitter.emit('set-unread-notifications-count', payload.unreadNotificationsCount);
    });
  }
}
